import { useAppDispatch } from "shared/lib/store";
import { toSelectTimeslot } from "../../model/timeslotsSlice";
import { scrollToSlot } from "../helpers/scroll/scroll";
import { clearLoadedTable, resetOrderDetail } from "entities/orders";
import { useTimeslotZone } from "./useTimeslotZone";

type toTimeslotProps = {
  hours?: string;
  clear?: boolean; 
}

export const useTimeslot = () => {
    const dispatch = useAppDispatch();
    const { formatISODateBySlotZone } = useTimeslotZone();

    const toTimeslot = (date: string, {hours,clear = false}:toTimeslotProps ) => {
        if (clear) {
          dispatch(clearLoadedTable());
          dispatch(resetOrderDetail());
        }


        dispatch(
            toSelectTimeslot({
                slot: date,
            }),
        );
        if (hours) {
            scrollToSlot(hours);
        }

    }

    const toTodayTimeSlot = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth();
      const date = currentDate.getDate();
      const hours = currentDate.getHours();
      let minutes = currentDate.getMinutes();

      if (minutes < 15) {
        minutes = 0
      }
      if (minutes >= 15 && minutes < 30) {
        minutes = 15
      }
      if (minutes >= 30 && minutes < 45) {
        minutes = 30
      }
      if (minutes >= 45 && minutes <= 59) {
        minutes = 45
      }
      // if (minutes > 45) {
      //   ++hours;
      //   minutes = 0
      // }
      const today = new Date(year, month, date, hours, minutes)
      toTimeslot(formatISODateBySlotZone(today), {})
    }

    return {
        toTimeslot,
        toTodayTimeSlot
    }
}
